import React from "react";
import { Link } from "react-router-dom";
import logo from '../assets/logo.png';
import hero from '../assets/hero.jpg';
// import herobackground from '../assets/herobackground.jpg';
import { useLocation } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import women_empowerment from '../assets/women_empowerment.jpg'


const styles = {
    body: {
        background: `url(${women_empowerment}) no-repeat center center / cover`,
        minHeight: "100vh",
    },
    navbarBrand: {
        fontWeight: 800,
        fontSize: "1.5rem",
        color: "white",
        display: "flex",
        alignItems: "center",
        textDecoration: "none",
    },
    navLinkActive: {
        color: "#00bfff",
        fontWeight: 700,
        marginRight: "15px"
    },

    icon: {
        color: "#00bfff",
        marginRight: "0.3rem",
    },
    navLink: {
        color: "white",
        fontWeight: 600,
        marginRight: "15px",
    },
    navLinkHover: {
        color: "#00bfff",
    },
    btnGetStarted: {
        backgroundColor: "#00bfff",
        border: "none",
        padding: "8px 20px",
        fontWeight: 600,
        borderRadius: "5px",
        marginRight: "60px"
    },
    heroSection: {
        // backgroundColor: "rgba(0, 0, 0, 0.6)",
        color: "white",
        // padding: "100px 30px 60px",
        minHeight: "90vh",
    },
    heroTitle: {
        fontWeight: 700,
        fontSize: "3rem",
        lineHeight: 1.2,
    },
    heroSubtitle: {
        marginTop: "15px",
        fontSize: "1rem",
        fontWeight: 400,
        color: "#ffffffff",
    },
    discoverBtn: {
        marginTop: "25px",
        backgroundColor: "#00bfff",
        color: "white",
        fontWeight: 600,
        padding: "10px 30px",
        borderRadius: "5px",
        border: "none",
    },
    infoCard: {
        background: "white",
        borderRadius: "15px",
        padding: "20px",
        maxWidth: "350px",
        boxShadow: "0 0 20px rgba(0,0,0,0.15)",
        color: "#031c40",
    },
    infoImg: {
        borderRadius: "15px",
        width: "100%",
        objectFit: "cover",
        marginBottom: "15px",
    },
    infoText: {
        fontSize: "1rem",
        fontWeight: 600,
    },
    satisfaction: {
        background: "#031c40",
        color: "white",
        borderRadius: "15px",
        padding: "25px 0",
        textAlign: "center",
        fontWeight: 700,
        marginTop: "15px",
        fontSize: "3rem",
        userSelect: "none",
    },
    satisfactionLabel: {
        fontSize: "1.2rem",
        marginTop: "-10px",
        fontWeight: 600,
    },
};

export const Navbar = () => {

    const location = useLocation();


    return (
        <nav className="navbar navbar-expand-lg px-1" style={{ background: "transparent" }}>
            <Link to='/' className="navbar-brand" style={styles.navbarBrand}>
                <img
                    src={logo}
                    style={{ height: "60px", width: "60px" }}
                />
                &nbsp;
                SURBHI FINANCES
            </Link>
            <button
                className="navbar-toggler bg-white btn btn-outline-light"
                type="button"

                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
            >
                ☰
            </button>
            <div className="collapse navbar-collapse justify-content-end" id="navbarNav">
                <ul className="navbar-nav align-items-center">
                    <Link
                        to='/'
                        className="nav-link"
                        style={location.pathname === '/' ? styles.navLinkActive : styles.navLink}
                    >
                        Home
                    </Link>

                    <Link
                        to='/about'
                        className="nav-link"
                        style={location.pathname === '/about' ? styles.navLinkActive : styles.navLink}
                    >
                        About Us
                    </Link>

                    <li className="nav-item">
                        <Link
                            to='/services'
                            className="nav-link"
                            style={location.pathname === '/services' ? styles.navLinkActive : styles.navLink}
                        >
                            Our Services
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to='/loan-repayment'
                            className="nav-link"
                            style={location.pathname === '/loan-repayment' ? styles.navLinkActive : styles.navLink}
                        >
                            Loan Repayment
                        </Link>
                    </li>
                    <li className="nav-item">
                        <Link
                            to='/contact'
                            className="nav-link"
                            style={location.pathname === '/contact' ? styles.navLinkActive : styles.navLink}
                        >
                            Contact Us
                        </Link>
                    </li>
                    <li className="nav-item ms-5">
                        {/* <button style={styles.btnGetStarted} className="btn">
                            LOGIN
                        </button> */}
                    </li>
                </ul>
            </div>
        </nav>
    );
};

const Hero = () => {

    const navigate = useNavigate();

    return (
        <section className="d-flex flex-column flex-lg-row align-items-center justify-content-between container-lg" style={styles.heroSection}>
            <div className="text-white flex-lg-grow-1 pe-lg-5">
                <h1 style={styles.heroTitle} className="raleway">Empowering Women with Easy Loans to Achieve Their<br /> Dreams.</h1>
                <p style={styles.heroSubtitle}>
                    Get quick, flexible, and hassle-free loans tailored for women — whether it’s personal, business, housing, or consumer needs. Your financial freedom starts here.
                </p>
                <button style={styles.discoverBtn} className="btn" onClick={() => navigate('/services')}>
                    Our Services
                </button>
            </div>

            <div style={styles.infoCard} className="mt-5 mt-lg-0">
                <img
                    src={hero}
                    alt="Small house"
                    style={styles.infoImg}
                />
                <p style={styles.infoText}>
                    {/* Get fast, <strong>transparent</strong>, and affordable mortgage options */}
                    Get quick, flexible, and affordable loans tailored for <strong>women.</strong>
                </p>
                <div style={styles.satisfaction}>
                    98%
                    <div style={styles.satisfactionLabel}>Satisfaction</div>
                </div>
            </div>
        </section>
    );
};

export default function NavHero() {
    return (
        <div style={{ position: "relative", minHeight: "100vh", overflow: "hidden" }}>
            {/* Background Image */}
            <img
                src={women_empowerment}
                alt="Background"
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    filter: "blur(1px)",
                    zIndex: 1,
                }}
            />

            {/* Dark overlay for contrast */}
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundColor: "rgba(0,0,0,0.4)",
                    zIndex: 2,
                }}
            ></div>

            {/* Navbar + Hero Content */}
            <div style={{ position: "relative", zIndex: 3 }}>
                <Navbar />
                <Hero />
            </div>
        </div>
    );


}